import { useMemo } from "react";

// Slow floating dust/ink particles. CSS-animated, GPU-friendly.
export default function Particles({ count = 22, color = "#C2A04A" }) {
  const dots = useMemo(
    () =>
      Array.from({ length: count }).map(() => ({
        left: Math.random() * 100,
        bottom: -(Math.random() * 30),
        size: Math.random() * 3 + 1,
        delay: Math.random() * 9,
        dur: Math.random() * 6 + 7,
        opacity: Math.random() * 0.4 + 0.15,
      })),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {dots.map((d, i) => (
        <span
          key={i}
          className="absolute rounded-full animate-floatUp"
          style={{
            left: `${d.left}%`,
            bottom: `${d.bottom}%`,
            width: d.size,
            height: d.size,
            background: color,
            opacity: d.opacity,
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.dur}s`,
          }}
        />
      ))}
    </div>
  );
}
